export const ClientActionTypes = {
    SET_CLIENT_ID: '@@client/SET_CLIENT_ID',
    SET_CLIENT_NAME: '@@client/SET_CLIENT_NAME',
};
